module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAYAAABc6S4mAAAAAXNSR0IArs4c6QAAAL9JREFUOBHtlTsKwlAQRc8kDwRBIWCt1graugMRK8HeJeiCbKwtrMTPCtyG1mLAgGCRjBPcwnuQIrec4tyZYS4DgSVc0zW5LojEr1WhIHpwFGyM3KcseFfUc0g8g3yKEHnlq7Uu8cUrs4ZVcwPCOR2DzlHxe0WihQXhaAavO0o3yPzCw5nL1uCrIDmAXZDGa2i1NvB/Ajdtk6V+H0IrUSbyFk7p3oK2DDO37C29OggDL6k6dGTJiMazGcTk2/n8AOqJL/XOdpqoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-column@2x.png
// module id = jo1C
// module chunks = 16